import React from 'react';
import { useDispatch } from 'react-redux';

import Text from 'components/core/Text';
import { changeProgramTrack } from 'actions/programs';
import { Wrapper, BackgroundStyled, Content, Buttons, ButtonCancel, ButtonConfirm } from './styles';

const ChangeTrack = ({ hideModal, modalData }) => {
  const dispatch = useDispatch();
  const { programId, trackId, trackName } = modalData;

  const handleConfirm = () => {
    dispatch(changeProgramTrack({ programId, trackId }));
    hideModal();
  };

  return (
    <>
      <BackgroundStyled onClick={hideModal} />
      <Wrapper>
        <Content>
          <Text variant="sectionHeader" tag="div" align="left" transform="none">
            CHANGE TO {trackName?.toUpperCase()} TRACK?
          </Text>
          <Text align="left" mt={5}>
            Switching tracks will restart your progress from the beginning of the new track.
          </Text>
          <Buttons>
            <ButtonCancel type="button" onClick={hideModal}>
              <Text tag="span" weight="bold">
                CANCEL
              </Text>
            </ButtonCancel>
            <ButtonConfirm type="button" onClick={handleConfirm}>
              <Text tag="span" weight="bold">
                CHANGE TRACK
              </Text>
            </ButtonConfirm>
          </Buttons>
        </Content>
      </Wrapper>
    </>
  );
};

export default ChangeTrack;
